export default {"src":"/_next/static/media/RBLX.7092e80c.svg","height":18,"width":18};